export const PAGE_TRANSITION = 850;
